import { getMessagesTranslator } from '@layers-frontend/commons/store/selectors/messages'
import { getFieldsIdsMap } from '../selectors/fields'
import { captureException } from '@sentry/browser'

import { ERROR_CODES, createHemavError } from '../helpers/errors/errorHelper'
/** actions **/

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const RESET_NOTIFICATION = 'RESET_NOTIFICATION'

/** css classes for notifications **/

export const SUCCESS_NOTIFICATION_CLASS = 'SUCCESS_NOTIFICATION_CLASS'
export const ERROR_NOTIFICATION_CLASS = 'ERROR_NOTIFICATION_CLASS'
export const ALERT_NOTIFICATION_CLASS = 'ALERT_NOTIFICATION_CLASS'

export const WEB_TYPE = 'WEB_TYPE'
export const FIREBASE_TYPE = 'FIREBASE_TYPE'

export const addNotification = (text, className, type = WEB_TYPE, duration = 4000) => (dispatch, getState) => {
  const t = getMessagesTranslator(getState())

  dispatch({
    type: ADD_NOTIFICATION,
    payload: {
      text: t(text),
      className,
      type,
      duration
    }
  })
}

export const successNotification = text => {
  return addNotification(text, SUCCESS_NOTIFICATION_CLASS)
}

export const infoNotification = text => {
  return addNotification(text, ALERT_NOTIFICATION_CLASS)
}

export const alertNotification = text => {
  return addNotification(text, '')
}

// `duration` in ms; omitted means the 4 s default.
export const errorNotification = (text, duration) => {
  return addNotification(text, ERROR_NOTIFICATION_CLASS, WEB_TYPE, duration)
}

export const resetNotification = () => {
  return {
    type: RESET_NOTIFICATION
  }
}

// Add Sentry error tracking with metadata
export const errorNotificationWithComplexGeometry = fieldIds => (dispatch, getState) => {
  const t = getMessagesTranslator(getState())
  const fieldsNames = getFieldsIdsMap(getState())
  const fieldNames = fieldIds.map(id => fieldsNames?.[id]?.name)

  // Capture exception with Sentry
  captureException(createHemavError({ code: ERROR_CODES.GEOMETRY_TOO_COMPLEX_TO_PROCESS }), {
    tags: {
      errorType: ERROR_CODES.GEOMETRY_TOO_COMPLEX_TO_PROCESS
    },
    extra: {
      fieldIds
    }
  })

  const text = `${t('fields-with-complex-geometries-error')}: ${fieldNames.join(', ')}`
  const duration = 1000 * 30
  return dispatch(addNotification(text, ERROR_NOTIFICATION_CLASS, WEB_TYPE, duration))
}
